export class AppFeedbackToken {
  static IAppFeedbackRepository = Symbol("IAppFeedbackRepository");
  static AppFeedbackUseCase = Symbol("AppFeedbackUseCase");
  static AppFeedbackViewModel = Symbol("AppFeedbackViewModel");
}
